/* Menu, zoekveld en uitklapmenu's van de header. Stond eerst inline in
   sections/header.liquid; als los bestand onthoudt de browser het. */
  (() => {
    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    const closeOtherDisclosures = (currentDisclosure) => {
      document.querySelectorAll('[data-header-disclosure][open]').forEach((disclosure) => {
        if (disclosure !== currentDisclosure) {
          disclosure.removeAttribute('open');
        }
      });
    };

    document.querySelectorAll('[data-header-disclosure]').forEach((disclosure) => {
      disclosure.addEventListener('toggle', () => {
        if (disclosure.open) {
          closeOtherDisclosures(disclosure);
          document.querySelectorAll('[data-header-search][open]').forEach((search) => {
            search.removeAttribute('open');
          });
        }
      });
    });

    /**
     * Mobile drawer: only one branch open at a time, per level.
     *
     * With every category expandable at once the drawer grew to several screens
     * of scrolling. Opening a sibling now collapses the others (and their
     * children), so the list stays roughly one screen tall.
     */
    document.querySelectorAll('.header__drawer-nested').forEach((nested) => {
      nested.addEventListener('toggle', () => {
        if (!nested.open) return;

        const siblings = nested.parentElement?.parentElement?.children || [];
        [...siblings].forEach((item) => {
          const other = item.querySelector(':scope > .header__drawer-nested[open]');
          if (other && other !== nested) {
            other.removeAttribute('open');
            other.querySelectorAll('.header__drawer-nested[open]').forEach((deep) => {
              deep.removeAttribute('open');
            });
          }
        });
      });
    });

    document.querySelectorAll('[data-header-search]').forEach((search) => {
      search.addEventListener('toggle', () => {
        if (!search.open) return;

        closeOtherDisclosures();
        document.querySelectorAll('[data-header-search][open]').forEach((item) => {
          if (item !== search) {
            item.removeAttribute('open');
          }
        });

        const input = search.querySelector('input[type="search"]');
        window.requestAnimationFrame(() => input?.focus());
      });
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-header-disclosure]')) return;
      document.querySelectorAll('[data-header-disclosure][open]').forEach((disclosure) => {
        disclosure.removeAttribute('open');
      });
      if (event.target.closest('[data-header-search]')) return;
      document.querySelectorAll('[data-header-search][open]').forEach((search) => {
        search.removeAttribute('open');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-header-disclosure][open]').forEach((disclosure) => {
        disclosure.removeAttribute('open');
      });
      document.querySelectorAll('[data-header-search][open]').forEach((search) => {
        search.removeAttribute('open');
      });
    });

    document.querySelectorAll('[data-header-drawer]').forEach((drawer) => {
      const toggle = drawer.querySelector('[data-header-drawer-toggle]');
      const panel = drawer.querySelector('[data-header-drawer-panel]');
      const closeButton = drawer.querySelector('[data-header-drawer-close]');
      let lastFocusedElement = null;

      const getFocusableElements = () =>
        [...panel.querySelectorAll(focusableSelector)].filter((element) => !element.hasAttribute('hidden'));

      const closeDrawer = () => {
        drawer.removeAttribute('open');
      };

      const handleKeydown = (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDrawer();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusableElements = getFocusableElements();
        if (!focusableElements.length) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      };

      closeButton?.addEventListener('click', (event) => {
        event.preventDefault();
        closeDrawer();
      });

      drawer.addEventListener('toggle', (event) => {
        if (event.target !== drawer) return;

        if (drawer.open) {
          lastFocusedElement = document.activeElement;
          document.documentElement.classList.add('header-drawer-open');
          document.body.classList.add('header-drawer-open');
          panel.addEventListener('keydown', handleKeydown);
          window.requestAnimationFrame(() => {
            const focusableElements = getFocusableElements();
            (focusableElements[0] || panel).focus();
          });
        } else {
          document.documentElement.classList.remove('header-drawer-open');
          document.body.classList.remove('header-drawer-open');
          panel.removeEventListener('keydown', handleKeydown);
          if (lastFocusedElement instanceof HTMLElement) {
            lastFocusedElement.focus();
          } else {
            toggle?.focus();
          }
        }
      });
    });

    const overlayHeader = document.querySelector('.header--overlay');
    if (overlayHeader) {
      const solidThreshold = 60;
      const updateOverlayState = () => {
        overlayHeader.classList.toggle('is-scrolled', window.scrollY > solidThreshold);
      };
      updateOverlayState();
      window.addEventListener('scroll', updateOverlayState, { passive: true });
    }
  })();
